module.exports = __webpack_public_path__ + "img/TRX-logo.acda5878.svg";